import { Box } from '@mui/material'
import { ArrowDropDownIcon } from '@mui/x-date-pickers'

export const FlagComponent = ({
  isoCode,
  countryName,
  isSelected,
}: {
  isoCode: string
  countryName: string
  isSelected: boolean
}) => {
  return (
    <Box
      sx={{
        padding: '0px 0px 0px 10px',
        display: 'flex',
        alignItems: 'center',
      }}
    >
      <img
        src={`https://flagcdn.com/16x12/${isoCode.toLowerCase()}.webp`}
        alt={countryName}
      />
      {isSelected ? (
        <Box
          component="span"
          sx={{
            padding: '0px',
            display: 'inline-flex',
            alignItems: 'center',
          }}
        >
          <ArrowDropDownIcon />
        </Box>
      ) : null}
    </Box>
  )
}
